import { Spinner } from "@next-platform/client-common-spicy-ui";
import type { ReactNode } from "react";

import PageStaticMetaTags from "@/components/common/PageStaticMetaTags";
import AnonymousMarketing from "@/pages/AnonymousMarketing/AnonymousMarketing";
import { CREATION_TAB_META_PAGE_ID } from "@/pages/Creations/creationTabMetaPageId";
import MyVoicesPage from "@/pages/Voice/MyVoicesPage";
import useAuth from "@/services/useAuth";

export default function MyVoices() {
  const { isAuthenticated, isLoading: isAuthLoading } = useAuth();

  let pageContent: ReactNode;
  if (isAuthLoading) {
    pageContent = <Spinner />;
  } else if (!isAuthenticated) {
    pageContent = <AnonymousMarketing datakey="creations" />;
  } else {
    pageContent = <MyVoicesPage />;
  }

  return (
    <>
      <PageStaticMetaTags pageId={CREATION_TAB_META_PAGE_ID.voices} data-testid="MyVoices-PageStaticMetaTags" />
      {pageContent}
    </>
  );
}
